export const CATEGORY_PLACEHOLDER = '{CATEGORY}';
export const PATH_PLACEHOLDER = '{PATH}';
export const LOGO_PLACEHOLDER = '{LOGO}';
